import React, { useEffect, useState } from 'react';
import { TabBar } from './TabManager';
import { useVbMenu, tabVisible } from '../utils/vbPerms';

// تاریخ امروز شمسی
function todayJalali() {
  const d = new Date();
  let gy = d.getFullYear(), gm = d.getMonth() + 1, gd = d.getDate();
  const gDM = [0,31,59,90,120,151,181,212,243,273,304,334];
  const gy2 = gy - 1600, gm2 = gm - 1, gd2 = gd - 1;
  let days = 365*gy2 + Math.floor((gy2+3)/4) - Math.floor((gy2+99)/100) + Math.floor((gy2+399)/400);
  days += gDM[gm2] + gd2;
  if (gm2 > 1 && ((gy%4===0 && gy%100!==0) || gy%400===0)) days += 1;
  let jDayNo = days - 79;
  const jNp = Math.floor(jDayNo / 12053);
  jDayNo %= 12053;
  let jy = 979 + 33*jNp + 4*Math.floor(jDayNo/1461);
  jDayNo %= 1461;
  if (jDayNo >= 366) { jy += Math.floor((jDayNo-1)/365); jDayNo = (jDayNo-1)%365; }
  const jDIM = [31,31,31,31,31,31,30,30,30,30,30,29];
  let jm = 0;
  while (jm < 11 && jDayNo >= jDIM[jm]) { jDayNo -= jDIM[jm]; jm++; }
  const p = n => String(n).padStart(2, '0');
  return `${String(jy).padStart(4,'0')}/${p(jm+1)}/${p(jDayNo+1)}`;
}

// هشدار پایان اعتبار
function isExpiringSoon(endDate) {
  endDate = (endDate || '').trim();
  if (!endDate) return false;
  const today = todayJalali();
  return today >= endDate;
}

export default function Dashboard({ user, onLogout, onNavigate }) {
  const [profile, setProfile]   = useState(user);
  const [tabs, setTabs]         = useState([]);
  const [loggingOut, setLoggingOut] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('access');

    // دریافت پروفایل
    fetch('/api/auth/profile/', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => r.json()).then(d => { if (d.ok) setProfile(p => ({ ...p, ...d.user })); }).catch(() => {});

    // دریافت دسترسی‌ها از JamBasicDatabase
    fetch('/api/auth/permissions/', {
      headers: { Authorization: `Bearer ${token}` }
    }).then(r => r.json()).then(d => {
      if (d.ok) setTabs(d.tabs || []);
    }).catch(() => {});
  }, []);

  const logout = async () => {
    setLoggingOut(true);
    try {
      await fetch('/api/auth/logout/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem('access')}` },
        body: JSON.stringify({ refresh: localStorage.getItem('refresh') }),
      });
    } catch {}
    localStorage.clear();
    onLogout();
  };

  const rc = profile?.role === 'admin'
    ? { bg:'#fff3e0', text:'#e65100', border:'#ffb74d' }
    : { bg:'#e3f2fd', text:'#1565c0', border:'#64b5f6' };

  const fmt = iso => iso ? new Date(iso).toLocaleString('fa-IR') : '—';

  // تعریف تب‌های منو با نام و آیکون
  const menuItems = [
    { key: 'TBACCOUNTING', icon: '📊', label: 'تنظیم حساب', color: '#1a3a5c', bg: '#e8f0fe', route: 'accounting' },
    { key: 'TBBUDGET',        icon: '💰', label: 'بودجه',            color: '#1b5e20', bg: '#e8f5e9', route: 'budget' },
    { key: 'TBCONTRACT',      icon: '📋', label: 'قراردادها',        color: '#4a148c', bg: '#f3e5f5', route: 'contract' },
    { key: 'TBDEPOSIT',       icon: '🏦', label: 'سپرده',            color: '#b71c1c', bg: '#ffebee', route: 'deposit' },
    { key: 'TBDEPOSITLOAN',   icon: '💳', label: 'وام سپرده',        color: '#e65100', bg: '#fff3e0' },
    { key: 'TBEDUCATION',     icon: '🎓', label: 'آموزش',            color: '#006064', bg: '#e0f7fa' },
    { key: 'TBEVALUATION',    icon: '⭐', label: 'رسیدگی',           color: '#f57f17', bg: '#fffde7', route: 'evaluation' },
    { key: 'TBINCOME',        icon: '💵', label: 'درآمد',            color: '#1b5e20', bg: '#f1f8e9', route: 'income' },
    { key: 'TBINOUT',         icon: '🔄', label: 'دریافت و پرداخت',  color: '#37474f', bg: '#eceff1', route: 'inout' },
    { key: 'TBPAYROL',        icon: '👥', label: 'حقوق و دستمزد',   color: '#880e4f', bg: '#fce4ec' },
    { key: 'TBPERSONELS',     icon: '🧑‍💼', label: 'پرسنل',          color: '#0d47a1', bg: '#e3f2fd' },
    { key: 'TBPREPARECREDIT', icon: '🏦', label: 'اعتبارات',         color: '#2e7d32', bg: '#e8f5e9', route: 'prepare_credit' },
    { key: 'TBPROPERTIES',    icon: '🏢', label: 'اموال',            color: '#4e342e', bg: '#efebe9', route: 'property' },
    { key: 'TBSYSTEM',        icon: '⚙️', label: 'سیستم',            color: '#212121', bg: '#f5f5f5', route: 'system' },
    { key: 'TBTADAROKAT',     icon: '📦', label: 'تدارکات',          color: '#1a237e', bg: '#e8eaf6', route: 'tadarokat' },
    { key: 'TBTREASURY',      icon: '🏛️', label: 'اعتبارات خزانه',   color: '#33691e', bg: '#f9fbe7', route: 'treasury' },
    { key: 'TBTREASURYPRECEPT', icon: '🧾', label: 'اسناد خزانه',    color: '#4e342e', bg: '#efebe9' },
    { key: 'TBZEMANAT',       icon: '🔐', label: 'ضمانت',            color: '#b71c1c', bg: '#fff3e0', route: 'zemanat' },
  ];

  // فقط تب‌هایی که کاربر دسترسی داره
  // تب فقط با سطر صریح همان تب دیده می‌شود (حتی برای دسترسی کامل) — از سرور.
  // صفحهٔ «سیستم» کاربران و گروه‌ها را هم دارد که زیر تب «تعاریف» (TBDEFINITION) هستند.
  const menu = useVbMenu();
  const allowedMenus = menuItems.filter(m => tabVisible(menu, m.key)
    || (m.key === 'TBSYSTEM' && tabVisible(menu, 'TBDEFINITION')));

  return (
    <div style={s.page}>
      {/* هدر */}
      <header style={s.header}>
        <div style={s.hLeft}>
          <div style={s.hLogo}>
            <img src={require('../assets/images/arjan.png')} alt="ارجان"
              style={{width:'36px',height:'36px',borderRadius:'8px'}} />
          </div>
          <div>
            <div style={s.hTitle}>سامانه ارجان</div>
            <div style={s.hSub}>اداره کل ورزش و جوانان</div>
          </div>
        </div>
        <div style={s.hRight}>
          <span style={{...s.pill, background:rc.bg, color:rc.text, borderColor:rc.border}}>
            {profile?.role_display}
          </span>
          <span style={s.hName}>{profile?.full_name}</span>
          <button onClick={logout} disabled={loggingOut} style={s.logoutBtn}>
            {loggingOut ? '...' : '🚪 خروج'}
          </button>
        </div>
      </header>

      <TabBar />

      <main style={s.main}>
        {/* خوش‌آمد */}
        <div style={s.welcome}>
          <div style={s.avatar}>{profile?.gender === 'مرد' ? '👨‍💼' : profile?.gender === 'زن' ? '👩‍💼' : '👤'}</div>
          <div style={{flex:1}}>
            <div style={s.wTitle}>خوش آمدید، {profile?.first_name || profile?.username}!</div>
            <div style={s.wSub}>ورود موفق — {new Date().toLocaleString('fa-IR')}</div>
          </div>
          {profile?.last_login && (
            <div style={s.lastBox}>
              <div style={s.lastLabel}>آخرین ورود</div>
              <div style={s.lastVal}>{fmt(profile.last_login)}</div>
              {profile.last_login_ip && <div style={s.lastIp}>{profile.last_login_ip}</div>}
            </div>
          )}
        </div>

        {/* کارت‌های اطلاعات */}
        <div style={s.grid}>
          {/* هویتی */}
          <div style={s.card}>
            <div style={s.cHead}><span>🪪</span><span>اطلاعات هویتی</span></div>
            <Row l="نام"          v={profile?.first_name} />
            <Row l="نام خانوادگی" v={profile?.last_name} />
            <Row l="نام پدر"      v={profile?.father_name} />
            <Row l="کد ملی"       v={profile?.melli_code} ltr />
            <Row l="تاریخ تولد"   v={profile?.birth_date} />
            <Row l="جنسیت"        v={profile?.gender} />
          </div>

          {/* تماس */}
          <div style={s.card}>
            <div style={s.cHead}><span>📞</span><span>اطلاعات تماس</span></div>
            <Row l="تلفن"       v={profile?.tel_no}      ltr />
            <Row l="کد پستی"    v={profile?.postal_code} ltr />
            <Row l="ایمیل"      v={profile?.email}       ltr />
            <Row l="نام کاربری" v={profile?.username}    ltr mono />
          </div>

          {/* سازمانی */}
          <div style={s.card}>
            <div style={s.cHead}><span>🏛️</span><span>اطلاعات سازمانی</span></div>
            <Row l="گروه کاربری" v={profile?.group_name} />
            <Row l="سطح دسترسی">
              <span style={{...s.pill, background:rc.bg, color:rc.text, borderColor:rc.border, fontSize:'12px'}}>
                {profile?.role_display}
              </span>
            </Row>
            <Row l="شناسه ارجان" v={profile?.arjan_user_id} ltr />
            <Row l="شروع اعتبار" v={profile?.start_date} ltr />
            <Row l="پایان اعتبار">
              <span style={{
                direction:'ltr', fontWeight:'600',
                color: isExpiringSoon(profile?.end_date) ? '#c62828' : '#1a1a2e'
              }}>
                {profile?.end_date || '—'}
                {isExpiringSoon(profile?.end_date) && (
                  <span style={{fontSize:'11px', color:'#c62828', marginRight:'6px'}}>⚠️ رو به اتمام</span>
                )}
              </span>
            </Row>
            {/* افتا بخش ۲-۸ */}
            <div style={s.aftaBox}>
              <div style={s.aftaTitle}>🛡️ پیشینه ورود ()</div>
              <ARow l="آخرین ورود موفق"    v={fmt(profile?.last_login)} />
              <ARow l="IP آخرین ورود"      v={profile?.last_login_ip || '—'} ltr />
              <ARow l="آخرین تلاش ناموفق" v={fmt(profile?.last_failed)} red={!!profile?.last_failed} />
              {profile?.failed_attempts > 0 && (
                <ARow l="تلاش‌های ناموفق" v={`${profile.failed_attempts} از ۵`} red />
              )}
            </div>
          </div>
        </div>

        {/* منوی دسترسی‌ها */}
        {allowedMenus.length > 0 && (
          <div style={s.menuSection}>
            <div style={s.menuTitle}>
              <span>🗂️</span>
              <span>دسترسی‌های سیستم</span>
              <span style={s.menuCount}>{allowedMenus.length} مورد</span>
            </div>
            <div style={s.menuGrid}>
              {allowedMenus.map(item => (
                <button key={item.key} style={{...s.menuBtn, background: item.bg}}
                  onClick={() => item.route ? onNavigate(item.route) : alert(`صفحه ${item.label} در حال توسعه است`)}>
                  <div style={{...s.menuIcon, color: item.color}}>{item.icon}</div>
                  <div style={{...s.menuLabel, color: item.color}}>{item.label}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {allowedMenus.length === 0 && tabs.length === 0 && (
          <div style={s.noAccess}>
            <span>⏳</span> در حال بارگذاری دسترسی‌ها...
          </div>
        )}
      </main>
    </div>
  );
}

function Row({ l, v, ltr, mono, children }) {
  return (
    <div style={r.row}>
      <span style={r.label}>{l}</span>
      <span style={{...r.val, direction:ltr?'ltr':'rtl', fontFamily:mono?'monospace':'inherit'}}>
        {children || v || '—'}
      </span>
    </div>
  );
}

function ARow({ l, v, ltr, red }) {
  return (
    <div style={r.aRow}>
      <span>{l}</span>
      <span style={{direction:ltr?'ltr':'rtl', color:red?'#c62828':'inherit', fontWeight:red?'600':'400'}}>{v}</span>
    </div>
  );
}

const r = {
  row:  { display:'flex', justifyContent:'space-between', alignItems:'center', padding:'9px 0', borderBottom:'1px solid #f5f5f5', gap:'12px' },
  label:{ fontSize:'13px', color:'#777', flexShrink:0 },
  val:  { fontSize:'14px', fontWeight:'600', color:'#1a1a2e', textAlign:'left' },
  aRow: { display:'flex', justifyContent:'space-between', fontSize:'12px', color:'#555', padding:'4px 0', gap:'8px' },
};

const s = {
  page:    { minHeight:'100vh', background:'#f0f2f7', fontFamily:"'Vazirmatn',Tahoma,sans-serif", direction:'rtl' },
  header:  { background:'linear-gradient(135deg,#0a1628,#1a2f50)', padding:'13px 26px', display:'flex', justifyContent:'space-between', alignItems:'center', boxShadow:'0 2px 16px rgba(0,0,0,0.3)', position:'sticky', top:0, zIndex:100 },
  hLeft:   { display:'flex', alignItems:'center', gap:'13px' },
  hLogo:   { width:'42px', height:'42px', background:'rgba(200,168,75,0.12)', border:'1px solid rgba(200,168,75,0.3)', borderRadius:'10px', display:'flex', alignItems:'center', justifyContent:'center' },
  hTitle:  { fontSize:'16px', fontWeight:'700', color:'#fff' },
  hSub:    { fontSize:'11px', color:'rgba(255,255,255,0.55)' },
  hRight:  { display:'flex', alignItems:'center', gap:'12px' },
  hName:   { fontSize:'13px', color:'#fff' },
  pill:    { padding:'3px 12px', borderRadius:'20px', fontSize:'12px', fontWeight:'600', border:'1.5px solid' },
  logoutBtn:{ padding:'7px 14px', background:'rgba(255,255,255,0.1)', color:'#fff', border:'1px solid rgba(255,255,255,0.25)', borderRadius:'8px', cursor:'pointer', fontFamily:'inherit', fontSize:'13px' },
  main:    { padding:'26px', maxWidth:'1100px', margin:'0 auto' },
  welcome: { background:'linear-gradient(135deg,#0a1628,#1a2f50)', color:'#fff', borderRadius:'15px', padding:'22px 26px', marginBottom:'22px', display:'flex', alignItems:'center', gap:'18px', flexWrap:'wrap', boxShadow:'0 6px 22px rgba(10,22,40,0.22)' },
  avatar:  { fontSize:'48px', lineHeight:1 },
  wTitle:  { fontSize:'19px', fontWeight:'700', marginBottom:'4px' },
  wSub:    { fontSize:'12px', opacity:0.75 },
  lastBox: { marginRight:'auto', background:'rgba(200,168,75,0.12)', border:'1px solid rgba(200,168,75,0.25)', borderRadius:'10px', padding:'10px 14px', textAlign:'center' },
  lastLabel:{ fontSize:'10px', opacity:0.7, marginBottom:'2px' },
  lastVal: { fontSize:'12px', fontWeight:'600', direction:'ltr' },
  lastIp:  { fontSize:'10px', opacity:0.65, marginTop:'2px', direction:'ltr', fontFamily:'monospace' },
  grid:    { display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(290px,1fr))', gap:'18px', marginBottom:'22px' },
  card:    { background:'#fff', borderRadius:'13px', padding:'20px', boxShadow:'0 2px 10px rgba(0,0,0,0.07)' },
  cHead:   { display:'flex', alignItems:'center', gap:'9px', marginBottom:'16px', paddingBottom:'12px', borderBottom:'2px solid #f0f2f7', fontSize:'14px', fontWeight:'700', color:'#1a2f50' },
  aftaBox: { marginTop:'14px', paddingTop:'13px', borderTop:'1.5px dashed #e8f0fe' },
  aftaTitle:{ fontSize:'12px', fontWeight:'700', color:'#1a2f50', marginBottom:'8px' },
  // منو دسترسی‌ها
  menuSection: { background:'#fff', borderRadius:'14px', padding:'22px', boxShadow:'0 2px 10px rgba(0,0,0,0.07)', marginBottom:'20px' },
  menuTitle: { display:'flex', alignItems:'center', gap:'10px', marginBottom:'18px', paddingBottom:'14px', borderBottom:'2px solid #f0f2f7', fontSize:'15px', fontWeight:'700', color:'#1a2f50' },
  menuCount: { marginRight:'auto', background:'#e8f0fe', color:'#1a2f50', padding:'2px 10px', borderRadius:'12px', fontSize:'12px', fontWeight:'600' },
  menuGrid:  { display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(130px,1fr))', gap:'14px' },
  menuBtn: {
    display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center',
    padding:'18px 10px', borderRadius:'14px', border:'none', cursor:'pointer',
    transition:'transform 0.15s, box-shadow 0.15s', gap:'10px',
    boxShadow:'0 2px 8px rgba(0,0,0,0.08)',
  },
  menuIcon:  { fontSize:'32px', lineHeight:1 },
  menuLabel: { fontSize:'13px', fontWeight:'700', textAlign:'center' },
  noAccess:  { textAlign:'center', padding:'20px', color:'#999', fontSize:'14px' },
};